module.exports = "<svg viewBox=\"0 0 11 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0h1v7H1V0zm0 12h1v3H1v-3zM0 8h3v3H0V8zm9-8h1v7H9V0zm0 12h1v3H9v-3zM8 8h3v3H8V8zm-2 7H5V8h1v7zM6 3H5V0h1v3zm1 4H4V4h3v3z\" class=\"ProgressBar-iconFill\" fill=\"none\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ProgressBarPane/tools.svg
// module id = 2034
// module chunks = 0